import { render, staticRenderFns } from "./CategoryBreadcrumbs.vue?vue&type=template&id=20f6e6ef&scoped=true"
import script from "./CategoryBreadcrumbs.vue?vue&type=script&lang=js"
export * from "./CategoryBreadcrumbs.vue?vue&type=script&lang=js"
import style0 from "./CategoryBreadcrumbs.vue?vue&type=style&index=0&id=20f6e6ef&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20f6e6ef",
  null
  
)

export default component.exports